import { FC } from 'react';
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Stack,
  Box,
  Heading,
  Button,
  Center,
  Checkbox,
} from '@chakra-ui/react';
import { useEditBaseStore } from '../../../hooks';
import {
  CrawlerIdInput,
  CrawlerNameInput,
  ImageNameInput,
  ApiKeyTemplateSelect,
} from '../../Forms';

type Props = ReturnType<typeof useEditBaseStore>;

export const CrawlerBaseInputModalView: FC<Props> = ({
  register,
  formState,
  onOpenModalEdit,
  apiKeyTemplates,
  isCheckUnnecessaryApiKey,
  setIsCheckUnnecessaryApiKey,
}) => (
  <Box p="32px" borderWidth="1px" borderColor="gray.300" rounded="md">
    <Heading as="h3" size="sm" mb="32px">
      基本情報
    </Heading>
    <Stack spacing="6" direction="column">
      <FormControl isInvalid={!!formState.errors.id}>
        <Stack direction="row" justify="space-between">
          <FormLabel pt="8px" w="180px">
            クローラーID
          </FormLabel>
          <Box flex="1">
            <CrawlerIdInput
              name="id"
              register={register}
              w="240px"
              variant="flushed"
              isReadOnly
              isTruncated
            />
            <FormErrorMessage>{formState.errors.id?.message}</FormErrorMessage>
          </Box>
        </Stack>
      </FormControl>
      <FormControl isInvalid={!!formState.errors.name} isRequired>
        <Stack direction="row" justify="space-between">
          <FormLabel pt="8px" w="180px">
            クローラー名
          </FormLabel>
          <Box flex="1">
            <CrawlerNameInput name="name" register={register} />
            <FormErrorMessage>
              {formState.errors.name?.message}
            </FormErrorMessage>
          </Box>
        </Stack>
      </FormControl>
      <FormControl isInvalid={!!formState.errors.imageName} isRequired>
        <Stack direction="row" justify="space-between">
          <FormLabel pt="8px" w="180px">
            イメージ名
          </FormLabel>
          <Box flex="1">
            <ImageNameInput name="imageName" register={register} />
            <FormErrorMessage>
              {formState.errors.imageName?.message}
            </FormErrorMessage>
          </Box>
        </Stack>
      </FormControl>
      <FormControl isInvalid={!!formState.errors.apiKeyTemplateId}>
        <Stack direction="row" justify="space-between">
          <FormLabel pt="8px" w="180px">
            APIキーテンプレート
          </FormLabel>
          <Box flex="1">
            <Box width="90%" display="inline-block">
              {isCheckUnnecessaryApiKey ? (
                <ApiKeyTemplateSelect
                  name="apiKeyTemplateId"
                  register={register}
                  isCheckUnnecessaryApiKey
                />
              ) : (
                <ApiKeyTemplateSelect
                  name="apiKeyTemplateId"
                  register={register}
                >
                  {apiKeyTemplates.map(({ id, name }) => (
                    <option value={id} key={id}>
                      {name}
                    </option>
                  ))}
                </ApiKeyTemplateSelect>
              )}
            </Box>
            <Box pl="5px" width="10%" display="inline-block">
              <Checkbox
                isChecked={isCheckUnnecessaryApiKey}
                onChange={setIsCheckUnnecessaryApiKey}
              >
                不要
              </Checkbox>
            </Box>
            <FormErrorMessage>
              {formState.errors.apiKeyTemplateId?.message}
            </FormErrorMessage>
          </Box>
        </Stack>
      </FormControl>
    </Stack>
    <Center mt="40px">
      <Button
        w="140px"
        colorScheme="blackAlpha"
        onClick={onOpenModalEdit}
        isDisabled={!formState.isValid}
      >
        確認
      </Button>
    </Center>
  </Box>
);
